module.exports = __webpack_public_path__ + "img/unstabilized_paved.062e651d.png";